export default "__VITE_ASSET__CGN3xCkx__"